<template>
    <div class="subscribe-to-product">
        <div v-if="!hasSubscribed">
            <header class="subscribe-to-product__header">
                <slot name="header"> </slot>
            </header>

            <slot name="description"></slot>

            <Form :errors="errors" @submitValid="subscribeToNewsletter" class="subscribe-to-product__form">
                <div class="form-group">
                    <input
                        type="email"
                        :placeholder="$t('Form.email.placeholder')"
                        :disabled="submitting"
                        v-model="email"
                        class="form-control input-gray"
                        required
                        :aria-label="$t('Form.email.placeholder')"
                    />
                </div>

                <div class="form-group">
                    <input
                        type="tel"
                        :placeholder="$t('Form.phone.placeholderOptional')"
                        :disabled="submitting"
                        v-model="phone"
                        class="form-control input-gray"
                        :aria-label="$t('Form.phone.placeholderOptional')"
                    />
                </div>

                <div class="text-center">
                    <button type="submit" :disabled="submitting" class="btn btn-primary btn-lg mx-auto">
                        {{ $t('Form.button.send') }}
                    </button>
                </div>
            </Form>

            <slot name="append"></slot>
        </div>

        <div v-else>
            <slot name="subscribed">
                <p>
                    {{ $t('ProductDetails.productSelect.soldOut.subscribedText', { hotel: productDetails.hotel }) }}
                    <!--TODO: probably unsubscribe call?-->
                </p>
            </slot>
        </div>
    </div>
</template>

<script>
import Form from '@/components/Form.vue';

export default {
    name: 'SubscribeToProductForm',

    components: { Form },

    data() {
        return {
            email: '',
            phone: '',
            subscriptions: this.$cookies.subscriptions,
            submitting: false,
            errors: []
        };
    },

    props: {
        productDetails: {
            type: Object,
            required: true
        }
    },

    computed: {
        subscriptionsObj: {
            get() {
                return JSON.parse(this.subscriptions) || {};
            },
            set(value) {
                this.subscriptions = JSON.stringify(value);
                this.$cookies.subscriptions = this.subscriptions;
            }
        },
        hasSubscribed() {
            return !!this.subscriptionsObj[this.productDetails.id];
        }
    },

    methods: {
        async subscribeToNewsletter() {
            const {
                email,
                phone,
                productDetails: { id: productId }
            } = this;

            this.errors = [];
            this.submitting = true;

            try {
                const isValueVoucher = this.productDetails.productCategory === "multivoucher"
                    || this.productDetails.productCategory === "valuevoucher";
                const url =  isValueVoucher
                    ? "/shop/voucher-product/subscribe-to-product"
                    : "/shop/hotel-product/subscribe-to-product"
                ;
                await this.$axios.post(url, {
                    email,
                    phone,
                    productId
                });
                this.subscriptionsObj = {
                    ...this.subscriptions,
                    [productId]: true
                };
            } catch (e) {
                this.$emit('error', e);

                this.errors = Array.isArray(e) ? e : [e];

                this.$isDev && console.error(e);
            } finally {
                this.submitting = false;
            }
        }
    },

    watch: {
        hasSubscribed: {
            handler(hasSubscribed) {
                hasSubscribed && this.$emit('subscribed');
            },
            immediate: true
        }
    }
};
</script>

<style scoped lang="scss">
@use '@/styles/variables';

.subscribe-to-product {
    padding: 1rem;

    &__header {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 0.5rem;
    }

    &__form {
        max-width: 400px;
        margin: 0 auto;

        &:not(:last-child) {
            margin-bottom: 1rem;
        }

        ::v-deep .error-messages {
            font-size: 14px;
        }

        ::v-deep .errors-container {
            padding-left: 0;
            padding-right: 0;
        }
    }
}
</style>
